import { Button } from '../../../components/Button/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarFooterButton = props => {
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: "tertiary-light",
    size: "xs",
    responsive: false
  }, props));
};